<template>
  <div class="ac-card-content">
    <div class="dc-header-container">
      <button
        class="dc-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="dc-close"
        >
      </button>
      <div class="dc-header">
        Delete Filter
      </div>
    </div>
    <div class="ac-body-container">
      Are you sure you want to delete this filter?
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button-two"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="deleteFilter"
      >
        Yes
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DeleteConfirm',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async deleteFilter() {
      this.processing = true;
      try {
        const { location } = this.selectedFilter;
        await this.$store.dispatch('deleteCustomerFilter', {
          id: this.selectedFilter.filterId,
        });
        await this.toggleActionModal(false);
        this.$store.dispatch('showSuccessToast', {
          header: 'Delete Filter.',
          message: `Your ${location} filter has been deleted!`,
        });
      } catch (err) {
        console.error(err);
        this.$store.dispatch('showAlertToast', {
          header: 'There was an unexpected error in deleting a filter.',
          message: 'Please try again or contact support',
        });
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.dc-header-container {
  padding: 29px 24px 19px 24px;
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid $NBLUE10;

  .dc-header {
    font-size: 1.25rem;
    font-weight: 500;
  }

  .dc-close-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: $NBLUE10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: $NBLUE20;
    }

    .dc-close {
      width: 10px;
      height: 10px;
    }
  }
}
</style>
